<template>
    <div class="book-service">
        <div class="mb-3 text-center" v-if="showLabel == true" v-html="siteWordings.search_instruction_one"></div>
        <form class="bookingsearch-form" id="addressSearch">
            <div class="input-group mb-2">
                <input type="text" class="form-control" :placeholder="searchPlaceholder" @keyup="search" v-model="pattern" />
                <loader-circle :classes="searchLoadingClasses" />
                <i
                    v-if="!clearAfterSelect && pattern && pattern != ''" 
                    role="button"
                    class="icon icon-close pointer"
                    aria-hidden="true"
                    @click="clearSearchString"></i>
                <i v-else class="icon icon-search" :class="searchIconHide" aria-hidden="true"></i>
                <searched-suggestion @clearPattern="() => clearSearchString()" />
            </div>
            <div v-if="isReducedView == false" class="font-italic" v-html="siteWordings.search_instruction_two"></div>
        </form>
    </div>
</template>

<script>
    import LoaderCircle from './LoaderCircle';
    import SearchedSuggestion from './SearchedSuggestion';
    import Texts from '../utils/Texts';
    import helper from '../../helper';

    export default {
        components: {
            SearchedSuggestion,
            LoaderCircle
        },
        props: {
            showLabel: {
                type: Boolean,
                default: true
            },
            isReducedView: {
                type: Boolean,
                default: false
            },
            clearAfterSelect: {
                type: Boolean,
                default: true
            },
            dark: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pattern: null,
                timerId: null,
                searchLoadingClasses: ['search-address-loading'],
                searchIconHide: []
            }
        },
        methods: {
            search() {
                if (this.pattern && this.pattern.trim().length < 3) {
                    return;
                }
                if (this.timerId) {
                    clearTimeout(this.timerId);
                }
                // this.$emit('onSearchAddress', false);
                // this.$store.dispatch('hardwaste/cwyClearEntitlement');
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                    if(this.pattern) {
                        this.searchLoadingClasses.push('loading-circle--show');
                        this.searchIconHide.push('d-none');
                        this.$store.dispatch('addressSearch', [this.pattern, 10]);
                    } else {
                        this.searchIconHide.splice(0,this.searchIconHide.length)
                        this.$store.dispatch('clearSearchedAddresses');
                    }
                }, 1000);
            },
            clearSearchString() {
                this.pattern = null;
                this.$emit("clearSearchString", true)
            }
        },
        mounted() {
            this.$store.dispatch("getAddressSetting");
            this.$store.dispatch('getStreetAbbreviations');
            if(this.dark) {
                this.searchLoadingClasses.push('search-address-loading--dark')
            }
            // this.$store.dispatch('getSiteWordingsSettings');
        },
        computed: {
            TEXTS: ()=> Texts,
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            activeAddress() {
                return this.$store.getters['GET_ACTIVE_ADDRESS']
            },
            doneSearch() {
                return this.$store.getters['GET_SEARCHED_ADDRESSES'].fetched && !this.$store.getters['GET_SEARCHED_ADDRESSES'].error
            },
            errorSearch() {
                return this.$store.getters['GET_SEARCHED_ADDRESSES'].error
            },
            searchPlaceholder(){
                var searchPlaceholder = this.siteWordings ? this.siteWordings.search_label : null
                searchPlaceholder = searchPlaceholder ? searchPlaceholder.replace(/<\/?[^>]+>/ig, "") : searchPlaceholder
                return searchPlaceholder || Texts.render(`BOOKING_SEARCH_BAR_PLACEHOLDER`) 
            }
        },
        watch: {
            'activeAddress': function(address) {
                if (address) {
                    this.pattern = this.clearAfterSelect ? null : (helper.addressTransform([address])[0].displayName || null);
                }
            },
            'doneSearch': function(done) {
                if (done) {
                    this.searchLoadingClasses.pop();
                    this.searchIconHide.pop()
                }
            },
            'errorSearch': function(error) {
                if (error) {
                    this.searchLoadingClasses.pop()
                }
            },
            pattern(val) {
                if(!val) {
                    this.$emit('clearSearch')
                }
            }
        },
    }
</script>